import { Injectable } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { CreateSalesOrderBatchModalComponent } from "./create-sales-order-batch.component";

@Injectable()
export class CreateSalesOrderBatchService {
  constructor(private dialogService: NbDialogService) {}

  createSalesOrderBatchModal(
    _salesOrderUUID: string,
    _salesOrderBatchUUID: string,
    hasTapes: boolean = false
  ) {
    const modal = this.dialogService.open(CreateSalesOrderBatchModalComponent, {
      context: {
        salesOrderUUID: _salesOrderUUID,
        salesOrderBatchUUID: _salesOrderBatchUUID,
        hasTapes: hasTapes,
      },
    });

    return new Promise((resolve, reject) => {
      modal.onClose.subscribe((result) => {
        resolve(result);
      });
    });
  }
}
